import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { getUserInfo } from '../../api/basic/user';

@Module
class User extends VuexModule {
  userInfo = {};
  @Mutation
  setUserInfo(data = {}): void {
    this.userInfo = data;
  }
  @Mutation
  clearUserInfo(): void {
    this.userInfo = {};
  }
  @Action({ commit: 'setUserInfo', rawError: true })
  async getUserInfo() {
    const resp = await getUserInfo();
    console.log('getUserInfo', resp);
    if (!resp) {
      // eslint-disable-next-line @retail/i18n-checker/require-translate
      throw new Error('Failed to get user info: empty response');
    }
    return resp.data;
  }
}
export default User;
